// extracted by mini-css-extract-plugin
module.exports = {"buttons":"UpgradeSuccessModal_buttons__2EYA1"};